import { defineAsyncComponent } from 'vue'
export default {
  main: defineAsyncComponent(() => import("/vercel/path0/layouts/main.vue").then(m => m.default || m))
}